import React from 'react'
import { Product } from '../../../common/models/cart'


const BasketItem: React.FC<Product> = ({ image, price, sku, optionKey, optionValue, quantity, name }) => {
    return (
        <li className="row">
            <div className="">
                <img src={image} alt=" " />
            </div>

            <div className="row column sm-mar-horizontal">
                <p className="font-overflow-hidden" title={name}>{name}</p>
                <p>SKU: {sku} </p>
                <div className="row font-center">
                    <p><span>{optionKey}:</span> <span>{optionValue} </span></p>
                    &nbsp;
                    <p>quantity: {quantity}</p>
                </div>
            </div>
            
            <div className="font-bold">
                {price}
            </div>
        </li>
    )
}

export default BasketItem;
